<section class="relative flex flex-col">
  <p-button
    icon="true"
    class="absolute top-[0.75rem] right-[0.75rem]"
    severity="contrast"
    rounded="true"
    styleClass="!size-[1.75rem] !px-0 !py-0"
    [text]="true"
    (click)="cancel()"
  >
    <svg-icon src="icons/icon-close-popup.svg" name="icon-close-popup" svgClass="!text-(--p-primary-200)"></svg-icon>
  </p-button>

  <div class="flex flex-col gap-4 px-5 pt-6 pb-5">
    <h3 class="text-[1rem] font-semibold text-(--p-primary-500) pr-8">{{ '@@ld-kpi-apply-filter-dialog__title' | translate }}</h3>

    <p class="text-[0.75rem] text-(--p-gray-950) leading-[1.5]">
      {{ '@@ld-kpi-apply-filter-dialog__description' | translate }}
    </p>

    <div class="flex items-center justify-between gap-3 pt-1">
      <div class="flex items-center gap-2">
        <p-checkbox
          class="flex"
          [binary]="true"
          [(ngModel)]="doNotShowAgain"
          inputId="doNotShowAgain"
        >
          <ng-template #checkboxicon>
            @if (doNotShowAgain) {
              <svg-icon src="icons/icon-checkmark-correct.svg"
                        name="icon-checkmark-correct"
                        class="text-(--p-surface-0) size-[0.5rem] shrink-0"></svg-icon>
            }
          </ng-template>
        </p-checkbox>
        <label for="doNotShowAgain" class="text-[0.75rem] text-(--p-gray-950) cursor-pointer select-none">
          {{ '@@ld-kpi-apply-filter-dialog__do-not-show-again-label' | translate }}
        </label>
      </div>

      <div class="flex items-center gap-2">
        <p-button
          [label]="'@@shared-cancel__text' | translate"
          [outlined]="true"
          styleClass="h-[2rem] !px-[0.95rem]"
          (onClick)="cancel()"
        />
        <p-button
          [label]="'@@ld-kpi-apply-filter-dialog__apply-btn' | translate"
          styleClass="h-[2rem] !px-[0.95rem]"
          (onClick)="apply()"
        />
      </div>
    </div>
  </div>
</section>
